import { throwError } from "@/lib/throwError";
import { axiosConfig } from "@/services/axiosConfig";
import {
  UserPermissions,
  UserPermissionsList,
  UserPermissionsPayload,
} from "@/utils/types/userPermissions";

const basePath = "/tenant-permissions/user-permissions";

class UserPermissionsService {
  getAllUserPermissions = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<UserPermissionsList> => {
    const response = await axiosConfig.get(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
    return response.data;
  };

  getUserPermissionsById = async (id: string): Promise<UserPermissions> => {
    if (!id) {
      throwError("ID is required", "UserPermissionsService");
    }
    const response = await axiosConfig.get(`${basePath}/${id}/`);
    return response.data;
  };

  createUserPermissions = async (
    payload: UserPermissionsPayload
  ): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "UserPermissionsService");
    }
    const response = await axiosConfig.post(`${basePath}/`, payload);
    return response.data;
  };

  updateUserPermissions = async (
    id: string,
    payload: UserPermissionsPayload
  ): Promise<any> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "UserPermissionsService");
    }
    const response = await axiosConfig.put(`${basePath}/${id}/`, payload);
    return response.data;
  };

  deleteUserPermissions = async (id: string): Promise<void> => {
    if (!id) {
      throwError("ID is required", "UserPermissionsService");
    }
    await axiosConfig.delete(`${basePath}/${id}/`);
  };
}

const instance = new UserPermissionsService();
export default instance;
